// extracted by mini-css-extract-plugin
export default {"UnloadPhotoOuterContainer":"unloadImage_UnloadPhotoOuterContainer__6DDl5","UnloadPhotoContainer":"unloadImage_UnloadPhotoContainer__Cm6SE"};